export const adminPageNames = {
  CLIENTS: 'clients',
  OBLIGATIONS: 'obligations',
  COMPANY_CODES: 'companyCodes',
  SL_ACCOUNTS: 'slAccounts',
  ADMIN_TAX_ENTRY_SETTINGS: 'adminTaxEntrySettings',
  TRIAL_BALANCE_THRESHOLD: 'trialBalanceThreshold',
  GL_JOURNALS: 'glJournals',
  CORRECTING_ENTRY_LIST: 'correctingEntryList',
  TAX_ACCOUNTING: 'taxAccountingSettings',
  TAX_BOOKING_ENTITIES: 'taxBookingEntities',
  LEGAL_ENTITIES: 'legalEntitySettings',
  GL_ACCOUNT_LIST: 'glAccountList',
  ACCOUNT_MAP: 'accountMap',
  TLS_ACCOUNTS: 'tlsAccountSettings',
  TAX_RATES: 'taxRates',
  COMMUNICATIONS_MANAGEMENT: 'communicationsManagement',
  BOOK_TO_TAX_CODE_DESCRIPTIONS: 'bookToTaxCodeDescriptions',
};

export const adminPageTitles = {
  CLIENTS: 'Clients',
  OBLIGATIONS: 'Obligation',
  COMPANY_CODES: 'Company Code',
  SL_ACCOUNTS: 'Balance Sheet Management Account',
  ADMIN_TAX_ENTRY_SETTINGS: 'Balance Sheet Management Tax Entry',
  ACCOUNT_TAGS: 'Account Tags',
  TRIAL_BALANCE_THRESHOLD: 'Trial Balance Out of Balance Threshold',
  GL_JOURNALS: 'Balance Sheet Management GL Journal',
  CORRECTING_ENTRY_LIST: 'Balance Sheet Management Correcting Entry',
  TAX_ACCOUNTING: 'Tax Accounting',
  TAX_BOOKING_ENTITIES: 'Tax Booking Entity',
  LEGAL_ENTITIES: 'Legal Entity',
  GL_ACCOUNT_LIST: 'Balance Sheet Management GL Account List',
  ACCOUNT_MAP: 'Account Map',
  TLS_ACCOUNTS: 'TLS Account',
  TAX_RATES: 'Tax Rates',
  COMMUNICATIONS_MANAGEMENT: 'Communications',
};
